<nav class="navbar navbar-light bg-light navbar-expand-lg mb-3">
  <div class="col-sm-12">
    <button class="btn btn-secondary float-end" (click)="cancelar()">Volver</button>
  </div>
</nav>
<form [formGroup]="tablaTanques">
  <label class="col-form-label"><b>Mediciones de tanques.</b></label>
  <table id="tabla" class="table table-sm table-striped table-hover header_fijo">
    <thead class="text-center">
      <tr>
        <th>Tanque</th>
        <th [width]="150">Fecha</th>
        <th>Hora</th>
        <th>Varillado MM.</th>
        <th>Cant. Natural</th>
        <th>Cant. 15°</th>
        <th>Temperatura</th>
        <th>Densidad</th>
        <th>Nivel de agua</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let t of tanques; let i = index; let j = index" class="text-center">
        <td class="fixedTitulo">{{t.nombre}} - {{t.productoActual.nombreProducto}}
          <div *ngIf="this.tanques[i].medicionCintelink" class="fechaHoraCintelink">
            Fecha y hora de medición Cintelink: {{t.mediciones.fechaHoraMedicion | date: "d'/'MM'/'y' 'hh:mm a"}}
          </div>
        </td>
        <td formArrayName="fecha">
          <input type="date" name="dt" [(ngModel)]="tanques[i].fechaProvisoria" formControlName="{{i}}"
            value="tanques[i].fechaProvisoria" max="{{fechaLimite | date:'yyyy-MM-dd'}}"  ngbDatepicker #d="ngbDatepicker" class="form-control" Datepicker />
        </td>
        <td formArrayName="hora">
          <ngb-timepicker [(ngModel)]="this.tanques[i].horaCarga" formControlName="{{i}}" [meridian]="true"
            [readonlyInputs]="false" [spinners]="false">
          </ngb-timepicker>
        </td>
        <td>
          <ng-container *ngIf="!obteniendoMediciones">
          <input class="form-control" (keyup)="changeValue(this.tanques[i].mediciones, 'varillado', $event); recalcularVolumenes(this.tanques[i], true); modificoMedicionCintelink(t);"
             (change)="this.tanques[i].medicionCintelink ? inputModificado() : null" appOnlyDecimal
            [value]="this.tanques[i].mediciones?.varillado ? this.tanques[i].mediciones.varillado : 0"
            (focus)="onFocusAlertaVarillado(i)" (blur)="onBlurAlertaVarillado()" maxlength="10">
          <div *ngIf="selectedIndex === i && mostrarMensajeAlertaVarillado" class="alert alert-warning">
            Si modifica el varillado también se modifica la cantidad natural y a 15º
          </div>
          </ng-container>
          <div class="loading-container" *ngIf="obteniendoMediciones">
            <loading-text-spinner class="me-4 spinner-symbol"  color="btn-primary">
            </loading-text-spinner>
            <div class="spinner-message">Cargando datos telemedición</div>
          </div>
        </td>
        <td>
          <ng-container *ngIf="!obteniendoMediciones">
          <input class="form-control" [disabled]="true" (keyup)="modificoMedicionCintelink(t);"
            [value]="this.tanques[i].mediciones?.nivelNatural ? this.tanques[i].mediciones.nivelNatural : 0">
          </ng-container>
          <div class="loading-container" *ngIf="obteniendoMediciones">
            <loading-text-spinner class="me-4 spinner-symbol"  color="btn-primary">
            </loading-text-spinner>
            <div class="spinner-message">Cargando datos telemedición</div>
          </div>
        </td>
        <td>
          <input class="form-control" [disabled]="true"
            [value]="this.tanques[i].mediciones?.nivel ? this.tanques[i].mediciones.nivel : 0">
        </td>
        <td>
          <ng-container *ngIf="!obteniendoMediciones">
          <input class="form-control" (keyup)="changeValue(this.tanques[i].mediciones, 'temperatura', $event); recalcularVolumen(tanques[i]); modificoMedicionCintelink(t);"
             (change)="this.tanques[i].medicionCintelink ? inputModificado() : null"
             (focus)="onFocusAlertaTemperatura(i)"
             (blur)="onBlurAlertaTemperatura()" appOnlyDecimalNegativa
             [value]="this.tanques[i].mediciones?.temperatura ? this.tanques[i].mediciones.temperatura : 0"
             maxlength="10">
          <div class="alert alert-danger letra" *ngIf="!validarTemperatura(this.tanques[i].mediciones?.temperatura.toString())">
            La temperatura no puede ser mayor a 100° ó menor a -50°.
          </div>
          <div *ngIf="selectedIndex === i && mensajeAlertaTemperatura" class="alert alert-warning">
            Si modifica la temperatura puede que se modifique la cantidad natural y a 15º
          </div>
          </ng-container>
          <div class="loading-container" *ngIf="obteniendoMediciones">
            <loading-text-spinner class="me-4 spinner-symbol"  color="btn-primary">
            </loading-text-spinner>
            <div class="spinner-message">Cargando datos telemedición</div>
          </div>
        </td>
        <td>
          <input class="form-control"
            (input)="onBlurDensidad(i, TipoContenedor.Tanque)"
            (paste)="onPaste(this.tanques[i].mediciones, $event, i, TipoContenedor.Tanque)"
            ngbTooltip="La densidad debe ser un valor entre {{this.esDensidadMinTanque[i]}} y {{this.esDensidadMaxTanque[i]}}"
            (keypress)="formatDensidad($event, i);"
            [value]="this.cadenaTanqueDensidad[i] ? this.cadenaTanqueDensidad[i] : 0" maxlength="10">
          <div class="alert alert-danger letra" *ngIf="!this.validateDensity(this.tanques[i].mediciones?.densidad ? this.tanques[i].mediciones.densidad.toString() : '',i ,TipoContenedor.Tanque)">
            La densidad debe estar en el rango [{{this.esDensidadMinTanque[i]}}, {{this.esDensidadMaxTanque[i]}}]
          </div>
        </td>
        <td>
          <ng-container *ngIf="!obteniendoMediciones">
          <input class="form-control" (keyup)="changeValue(this.tanques[i].mediciones, 'nivelAgua', $event); recalcularVolumenes(this.tanques[i], false)"
                 (change)="this.tanques[i].medicionCintelink ? inputModificado() : null"
                 (focus)="onFocusAlertaNivelAgua(i)"
                 (blur)="onBlurAlertaNivelAgua()"
                 [value]="this.tanques[i].mediciones?.nivelAgua === null ? '' : this.tanques[i].mediciones.nivelAgua"
                 appOnlyDecimal maxlength="10">
          <div *ngIf="selectedIndex === i && mensajeAlertaNivelAgua" class="alert alert-warning">
            Si modifica el Nivel Agua puede que se modifique la cantidad natural y a 15º
          </div>
          <div *ngIf="this.tanques[i].mediciones?.nivelAgua === null" class="alert alert-danger">
            Campo obligatorio
          </div>
          </ng-container>
          <div class="loading-container" *ngIf="obteniendoMediciones">
            <loading-text-spinner class="me-4 spinner-symbol"  color="btn-primary">
            </loading-text-spinner>
            <div class="spinner-message">Cargando datos telemedición</div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <form [formGroup]="tablaAbastecedora">
    <label class="col-form-label"><b>Mediciones de abastecedoras.</b></label>
    <table id="tabla" class="table table-sm table-striped table-hover header_fijo">
      <thead class="text-center">
        <tr>
          <th>Abastecedora</th>
          <th [width]="150">Fecha</th>
          <th>Hora</th>
          <th>Varillado Lts.</th>
          <th>Cant. Natural</th>
          <th>Cant. 15°</th>
          <th>Temperatura</th>
          <th>Densidad</th>
          <th>Nivel de agua</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let a of abastecedoras; let i = index; let j = index" class="text-center">
          <td>{{abastecedoras[i].nombre}} - {{abastecedoras[i].productoActual.nombreProducto}} </td>
          <td formArrayName="fecha">
            <input type="date" name="dt" [(ngModel)]="abastecedoras[i].fechaProvisoria" formControlName="{{i}}"
              value="abastecedoras[i].fechaProvisoria" max="{{fechaLimite | date:'yyyy-MM-dd'}}" ngbDatepicker #d="ngbDatepicker" class="form-control"
              Datepicker />
          </td>
          <td formArrayName="hora">
            <ngb-timepicker [(ngModel)]="this.abastecedoras[i].horaCarga" formControlName="{{i}}" [meridian]="true"
              [readonlyInputs]="false" [spinners]="false">
            </ngb-timepicker>
          </td>
          <td>
            <input class="form-control" (keyup)="changeValue(this.abastecedoras[i].mediciones, 'varillado', $event)"
              (blur)="recalcularVolumen15Abastecedora(this.abastecedoras[i])" appOnlyDecimal
              [value]="this.abastecedoras[i].mediciones?.varillado ? this.abastecedoras[i].mediciones.varillado : 0" maxlength="10">
          </td>
          <td>
            <input class="form-control" [disabled]="true"
              [value]="this.abastecedoras[i].mediciones?.nivelNatural ? this.abastecedoras[i].mediciones.nivelNatural : 0">
          </td>
          <td>
            <input class="form-control" [disabled]="true"
              [value]="this.abastecedoras[i].mediciones?.nivel ? this.abastecedoras[i].mediciones.nivel : 0">
          </td>
          <td>
            <input class="form-control" (keyup)="changeValue(this.abastecedoras[i].mediciones, 'temperatura', $event)"
              (blur)="recalcularVolumen15Abastecedora(this.abastecedoras[i])" appOnlyDecimalNegativa
              [value]="this.abastecedoras[i].mediciones?.temperatura ? this.abastecedoras[i].mediciones.temperatura : 0" maxlength="10">
            <div class="alert alert-danger letra"
              *ngIf="!validarTemperatura(this.abastecedoras[i].mediciones?.temperatura.toString())">
              La temperatura no puede ser mayor a 40°.
            </div>
          </td>
          <td>
            <input class="form-control"
              (input)="onBlurDensidad(i, TipoContenedor.Abastecedora)"
              (paste)="onPaste(this.abastecedoras[i].mediciones, $event, i, TipoContenedor.Abastecedora)"
              ngbTooltip="La densidad debe ser un valor entre {{this.esDensidadMinAbast[i]}} y {{this.esDensidadMaxAbast[i]}}"
              (keypress)="formatDensidadAbastecedora($event, i)"
              [value]="this.cadenaAbastecedoraDensidad[i] ? this.cadenaAbastecedoraDensidad[i] : 0">
            <div class="alert alert-danger letra" *ngIf="!this.validateDensity(this.abastecedoras[i].mediciones?.densidad ? this.abastecedoras[i].mediciones.densidad.toString() : '', i, TipoContenedor.Abastecedora) " maxlength="10">
              La densidad debe estar en el rango [{{this.esDensidadMinAbast[i]}}, {{this.esDensidadMaxAbast[i]}}]
            </div>
          </td>
          <td>
            <input class="form-control" (keyup)="changeValue(this.abastecedoras[i].mediciones, 'nivelAgua', $event)"
              (blur)="recalcularVolumen15Abastecedora(this.abastecedoras[i])" appOnlyDecimal
              [value]="this.abastecedoras[i].mediciones?.nivelAgua ? this.abastecedoras[i].mediciones.nivelAgua : 0" maxlength="10">
          </td>
        </tr>
      </tbody>
    </table>
    <div class="float-end">
      <button class="btn btn-primary" [disabled]="guardandoMediciones || obteniendoMediciones" (click)="guardarMedicionesMasivas()">
        <span *ngIf="!guardandoMediciones">Guardar</span>
        <div *ngIf="guardandoMediciones" class="d-flex align-items-center">
          <div class="spinner-border text-light spinner-border-sm" role="status"></div>
          <span>Guardando...</span>
        </div>
      </button>
    </div>
  </form>
